const cats = ['Working Hours', 'Blackout', 'Lead Time', 'Buffer', 'Resource'];

export const schedulingRulesList = Array.from({ length: 12 }, (_, i) => ({
  id: `sr-${i}`,
  name: `Rule ${i + 1}: ${['No Friday PM', 'Exec buffer', 'External cap', 'Room priority', 'Min lead 2h'][i % 5]}`,
  category: cats[i % 5],
  priority: 12 - i,
  enabled: i % 7 !== 0,
  scope: i % 2 === 0 ? 'department:Sales' : 'global',
  effectiveFrom: new Date(Date.now() - i * 86400000 * 10).toISOString(),
  conflicting: i % 9 === 0,
  conflictHint: i % 9 === 0 ? 'Overlaps with SR-blackout-1' : null,
}));

export const workingHoursConfig = {
  timezone: 'Asia/Muscat',
  weekdays: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].map((day, idx) => ({
    day,
    label: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][idx],
    enabled: idx < 5 || idx === 6,
    start: idx === 6 ? '09:00' : '08:00',
    end: idx === 6 ? '13:00' : '17:00',
  })),
  exceptions: [
    { id: 'ex-1', date: '2025-12-25', description: 'Christmas', type: 'Holiday' },
    { id: 'ex-2', date: '2025-03-23', description: 'Short Friday', type: 'Short Day' },
  ],
};

export const resourceRulesList = Array.from({ length: 8 }, (_, i) => ({
  id: `rr-${i}`,
  name: ['Boardroom A', 'VC Suite', 'Projector Kit', 'Zoom Room 3'][i % 4] + (i > 3 ? ` ${i}` : ''),
  resourceType: i % 3 === 0 ? 'Room' : i % 3 === 1 ? 'Equipment' : 'Virtual',
  capacity: i % 3 === 0 ? 12 : i % 3 === 1 ? 1 : 50,
  maxBookingMinutes: 60 + i * 30,
  approvalRequired: i % 4 === 0,
  approverRole: i % 4 === 0 ? 'tenant_admin' : null,
  availabilitySource: ['Shared Calendar', 'Manual', 'External'][i % 3],
  blackouts: i % 2 === 0 ? ['2025-04-01'] : [],
  status: i === 3 ? 'unavailable' : 'available',
  bufferMinutes: i % 3 === 0 ? 15 : 0,
}));
